import { Check, AlertCircle } from "lucide-react";

export const ChoiceGrid = ({ name, options, value, onSelect, multiple = false, error, legend, testPrefix, hint }) => {
  const selected = (opt) => (multiple ? value.includes(opt) : value === opt);
  return (
    <fieldset>
      <legend className="sr-only">{legend}</legend>
      <div role={multiple ? "group" : "radiogroup"} className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {options.map((opt) => {
          const on = selected(opt);
          return (
            <button
              type="button"
              key={opt}
              role={multiple ? "checkbox" : "radio"}
              aria-checked={on}
              onClick={() => onSelect(opt)}
              className={`group flex min-h-[56px] items-center justify-between gap-3 rounded-2xl border px-4 py-3.5 text-left text-sm sm:text-base font-medium transition-[border-color,background-color,box-shadow,transform] duration-300 active:scale-[0.99] ${
                on ? "border-violet-400/70 bg-violet-500/15 text-white shadow-[0_0_0_4px_rgba(139,92,246,0.12)]" : "border-white/10 bg-white/[0.02] text-slate-300 hover:border-white/25 hover:bg-white/[0.05]"
              }`}
              data-testid={`${testPrefix}-${opt.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`}
            >
              {opt}
              <span className={`grid h-6 w-6 shrink-0 place-items-center rounded-full border transition-[background-color,border-color] duration-300 ${on ? "border-transparent bg-gradient-to-br from-indigo-500 to-violet-500 text-white" : "border-white/15 text-transparent"} ${multiple ? "rounded-lg" : ""}`} aria-hidden="true">
                <Check className="h-3.5 w-3.5" />
              </span>
            </button>
          );
        })}
      </div>
      {hint && !error && <p className="mt-3 text-xs text-slate-500">{hint}</p>}
      {error && <p role="alert" className="mt-3 flex items-center gap-1.5 text-sm text-rose-300" data-testid={`${name}-error`}><AlertCircle className="h-4 w-4" aria-hidden="true" /> {error}</p>}
    </fieldset>
  );
};
